import React from "react";
import {makeStyles} from "@material-ui/core";
import GridBlock from "components/GridBlock";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import ToggleButton from "@material-ui/lab/ToggleButton";
import PropTypes from "prop-types";
import AgreementListType from "../constants/AgreementListType";
import Tr from "translations/Translations"

const useStyles = makeStyles(theme => ({
    root: {
      marginBottom: theme.spacing(3)
    },
    button: {
        width: 560,
    }

}));

function AgreementsListType(
    {
        listType,
        setListType
    }) {

    const classes = useStyles();

    const handleToggleClick = (event, newProcedure) => {
        if (newProcedure)
            setListType(newProcedure);
    };

    return (<GridBlock column className={classes.root}>
            <GridBlock justify="center">
                <ToggleButtonGroup size="medium" value={listType} exclusive onChange={handleToggleClick}>
                    <ToggleButton classes={{root: classes.button}} value={AgreementListType.AVAILABLE}>
                        {Tr("agreements_available")}
                    </ToggleButton>
                    <ToggleButton classes={{root: classes.button}} value={AgreementListType.CREATED}>
                        {Tr("agreements_created")}
                    </ToggleButton>
                </ToggleButtonGroup>
            </GridBlock>
        </GridBlock>
    )
}

AgreementsListType.propTypes = {
    listType: PropTypes.string.isRequired,
    setListType: PropTypes.func.isRequired
}

export default AgreementsListType;

